import { BaseEntityModel } from '../../core/abstractions/base-entity.model';

export class TreeItemModel extends BaseEntityModel {
    name: string;
    children: TreeItemModel[] = [];

    constructor(init?: Partial<TreeItemModel>) {
        super();
        Object.assign(this, init);
    }
}
